{
  "VALIDATION_FAILED": "The submitted data is not valid",
  "USERNAME_TAKEN": "This username is already in use",
  "NO_PLATFORM_ACCESS": "You do not have access to this platform",
  "UA_UNAVAILABLE": "Unified Access could not be reached. Try again shortly.",
  "UNAUTHENTICATED": "You need to sign in",
  "INVALID_CREDENTIALS": "Invalid email or password",
  "TOKEN_EXPIRED": "Your session expired",
  "TOKEN_REVOKED": "This session was revoked",
  "FORBIDDEN": "You do not have permission for this action",
  "NOT_FOUND": "The requested item was not found",
  "routeNotFound": "This page does not exist.",
  "CONFLICT": "Conflicting data. Reload the current data.",
  "UNIQUE_VIOLATION": "This value is already in use",
  "FOREIGN_KEY_VIOLATION": "This item is referenced elsewhere and cannot be deleted",
  "RATE_LIMITED": "Too many attempts. Try again shortly.",
  "IDEMPOTENCY_KEY_REUSED": "This request number was already used for another operation",
  "REQUEST_IN_PROGRESS": "This request is still being processed",
  "PAYLOAD_TOO_LARGE": "The submitted data exceeds the maximum size",
  "UNPROCESSABLE": "The request could not be processed. Check the submitted data.",
  "INTERNAL_ERROR": "The operation could not be completed. Try again or contact your administrator.",
  "SERVICE_UNAVAILABLE": "The service is unavailable right now. Try again shortly.",
  "IN_USE": "It cannot be deleted because it is in use. You can disable it instead.",
  "BRANCH_NOT_ALLOWED": "Not available in this branch",
  "CODE_TAKEN": "This code is already in use",
  "INVALID_STATE": "This action is not possible in the current state",
  "NOTHING_TO_CHANGE": "There are no changes to save",
  "CUSTOMERS_UNAVAILABLE": "Could not link to the Customers platform, try again",
  "PHONE_TAKEN": "This phone number belongs to another customer in Customers",
  "CUSTOMER_DELETED": "The customer was deleted in Customers, its phone cannot be changed",
  "CUSTOMERS_FORBIDDEN": "Customers refused the phone change for this system",
  "DEBT_LIMIT_EXCEEDED": "The amount plus the current debt exceeds the debt limit of {{limit}} JOD",
  "MOVEMENT_DATE_IN_FUTURE": "The transaction date cannot be in the future",
  "MOVEMENT_BEFORE_LOCKED": "The transaction date cannot be before the last migrated movement ({{date}})",
  "ACCOUNT_BALANCE_NOT_ZERO": "An account whose balance is not zero cannot be deleted",
  "network": "Could not reach the server. Check your connection and try again.",
  "timeout": "We could not confirm this finished. Check the current state before trying again.",
  "referenceId": "Reference: {{requestId}}",
  "PHONE_EXISTS": "The phone number is registered to the customer {{name}}",
  "ACCOUNT_NAME_EXISTS": "An account with this name already exists for this customer in this branch",
  "PHONE_REQUIRED": "The phone number is required",
  "PHONE_INVALID": "The phone number is not valid",
  "PHONE_NOT_MOBILE": "Landline numbers are not allowed. Enter a mobile number",
  "PHONE_COUNTRY_NOT_ALLOWED": "Numbers from this country are not accepted",
  "PHONE_VERIFICATION_REQUIRED": "Verify the phone number before saving",
  "PHONE_VERIFICATION_INVALID": "The phone verification expired. Verify again",
  "PHONE_VERIFICATION_RECEIPT_EXPIRED": "The phone verification expired. Verify again",
  "OTP_INVALID": "The code is incorrect",
  "OTP_EXPIRED": "The code has expired. Request a new code",
  "OTP_ATTEMPTS_EXCEEDED": "Too many wrong attempts. Request a new code",
  "OTP_RESEND_TOO_SOON": "The code cannot be resent yet",
  "OTP_SEND_LIMIT": "Too many codes were sent to this number",
  "OTP_SEND_FAILED": "The verification code could not be sent by WhatsApp. Nothing was saved. Try again, or an administrator can turn verification off in the settings",
  "OTP_ALREADY_VERIFIED": "The phone number has been verified",
  "OTP_ALREADY_CONSUMED": "The code has expired. Request a new code",
  "OTP_BINDING_MISMATCH": "The code has expired. Request a new code",
  "OTP_NOT_VERIFIED": "Verify the phone number before saving",
  "OTP_CONSUME_WINDOW_PASSED": "The code has expired. Request a new code",
  "IDEMPOTENCY_CONFLICT": "This request number was already used for another operation",
  "REVERIFY_NOT_NEEDED": "Verifying again is not needed for this customer",
  "CUSTOMER_PROFILE_INCOMPLETE": "The customer's details are incomplete. Complete them before any debit or credit movement",
  "DEBTOR_MERGE_NOT_ALLOWED": "The accounts of this customer cannot be moved",
  "DEBTOR_MERGE_STALE": "The customers' details changed meanwhile. Close the window and try again",
  "DEBTOR_MERGE_HIDDEN_NAME_CONFLICT": "An account name in another branch is already used there by {{name}}. Ask an employee of that branch to rename it.",
  "CUSTOMERS_CALL_IN_FLIGHT": "The customer's details are being sent to the Customers system; try again in a moment"
}
